import { Box, Button, Typography } from "@material-ui/core";
import React from "react";
import Modal from "src/shared/components/Modal";
import {
  CLOSE_MODAL_BUTTON_LABEL,
  GET_RESET_SEASONS_CONFIRMATION,
  MODAL_HEADING,
  RESET_SETTINGS_BUTTON_LABEL,
} from "./constants";
import { IDefaultSettingsModalProps } from "./types";
import { useStyles } from "./styles";

export const DefaultSettingsModal = ({
  closeDefaultSettingsModal,
  isDefaultSettingsModalOpen,
  schoolName,
  setSeasonsToDefault,
}: IDefaultSettingsModalProps) => {
  const classes = useStyles();
  return (
    <Modal
      open={isDefaultSettingsModalOpen}
      closeModal={closeDefaultSettingsModal}
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="space-between"
      >
        <Box>
          <Box marginBottom="1.5rem">
            <Typography variant="h4">{MODAL_HEADING}</Typography>
          </Box>
          <Typography variant="body1">
            {GET_RESET_SEASONS_CONFIRMATION(schoolName)}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Button onClick={closeDefaultSettingsModal} variant="contained">
            {CLOSE_MODAL_BUTTON_LABEL}
          </Button>
          <Button
            className={classes.resetToDefaultButton}
            onClick={setSeasonsToDefault}
            variant="contained"
            color="primary"
          >
            {RESET_SETTINGS_BUTTON_LABEL}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/components/default-settings-modal/DefaultSettingsModal.tsx